import { Component, OnInit, AfterViewInit } from "@angular/core";
import { SchoolService } from "../../../../shared/services/school.service";
import { AdminSetupService } from "../../services/adminsetup.service";
import { Router, ActivatedRoute } from "@angular/router";
//import { UserService } from '../../../../shared/services/user.service';
import { HttpclientService } from "../../../../shared/services/httpclient.service";
import { Subscription } from "rxjs";

declare var moment: any;

@Component({
	selector: "caass-adminsetup-addnotification",
	templateUrl: "./addnotification.component.html",
})
export class AddNotificationComponent implements OnInit {
	subscription: Subscription;

	notification = {
		NotificationTypeID: 0,
		LanguageID: 0,
		IncludeFirstName: true,
		Active: true,
		IncludeEntryDate: true,
		IncludeEntryTime: true,
		NotificationID: 0,
		NotificationSchoolID: 0,
		SchoolID: 0,
		Message: "",
		AdmitTime: 0,
	};

	AdmitTime: boolean;
	schoolList: any = [];
	processing: any = false;
	SaveErrorMessage = "";

	IncludeEntryDate: boolean;

	enable_IncludeEntryDate = false;
	IncludeEntryDate_label = "Include Entry Date";

	enable_IncludeEntryTime = false;
	IncludeEntryTime_label = "Include Entry Time";

	ngOnInit() {
		this.loadSchoolist();
		this.LanguageTypeGetList();
	}

	constructor(
		private schoolService: SchoolService,
		private router: Router,
		private route: ActivatedRoute,

		private httpclientService: HttpclientService,
		private adminSetupService: AdminSetupService
	) {}

	notificationTypeList: any = [];
	languageList: any = [];
	messageList: any = [];

	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "Select a School",
					});
				} else {
					this.notification.SchoolID = this.schoolList[0].SchoolID;
					this.NotificationTypeGetList();
				}
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.notification.SchoolID = value;
		this.NotificationTypeGetList();
	}

	private NotificationTypeGetList() {
		this.notification.NotificationTypeID = 0;
		var result = this.adminSetupService.NotificationTypeSelectList(this.notification.SchoolID);
		result.subscribe(
			(response) => {
				this.notificationTypeList = response;

				if (this.notificationTypeList.length > 1) {
					this.notificationTypeList.unshift({
						NotificationTypeID: 0,
						NotificationTypeDesc: "All Notification  Type",
					});
				} else {
					this.notification.NotificationTypeID = this.notificationTypeList[0].NotificationTypeID;
				}
			},
			(error) => {}
		);
	}

	private LanguageTypeGetList() {
		var result = this.adminSetupService.LanguageTypeGetList();

		result.subscribe(
			(response: any) => {
				this.languageList = response;

				this.languageList.unshift({
					LanguageID: 0,
					LanguageDesc: "Select a Language",
				});
			},
			(error) => {}
		);
	}

	onChangeNotificationType(value) {
		this.notification.NotificationTypeID = value;
		this.changeView();
	}

	private changeView() {
		var value = this.notification.NotificationTypeID;
		this.enable_IncludeEntryDate = false;
		this.enable_IncludeEntryTime = false;
		this.notification.Active = false;
		this.IncludeEntryDate_label = "Include Entry Date";
		this.IncludeEntryTime_label = "Include Entry Time";

		if (value == 1) {
			// Attendance, Present and On-Time

			this.enable_IncludeEntryDate = true;
			this.enable_IncludeEntryTime = true;
			this.notification.Active = true;
			this.IncludeEntryDate_label = "Include Entry Date";
			this.IncludeEntryTime_label = "Include Entry Time";
			this.notification.Message = " Your Child [firstname] arrived on [entrydate] at [entrytime]";
		}

		if (value == 2) {
			// Attendance, Tardy
			this.enable_IncludeEntryDate = true;
			this.enable_IncludeEntryTime = true;
			this.notification.Active = true;
			this.IncludeEntryDate_label = "Include Entry Date";
			this.IncludeEntryTime_label = "Include Entry Time";
			this.notification.Message = "Your child [firstname] entered school on [entrydate] at [entrytime]. School starts at 8:45am ";
		}
		if (value == 3) {
			//  Attendance, Absent
			this.notification.Active = false;
			this.notification.Message = " [firstname]Your child  is currently absent from school.";
		}
		if (value == 4) {
			//  Incident
			this.notification.Active = true;
			this.notification.Message = " [firstname]";
		}

		if (value == 6) {
			//  Class Attendance, Cut
			this.notification.Active = true;
			this.notification.Message = "vjhuyj";
		}

		if (value == 8) {
			// Exit School

			this.enable_IncludeEntryDate = true;
			this.enable_IncludeEntryTime = true;
			this.notification.Active = true;
			this.IncludeEntryDate_label = "Include Entry Date";
			this.IncludeEntryTime_label = "Include Entry Time";
			this.notification.Message = " [firstname]";
		}
	}

	onFirstNameChange(isChecked) {
		if (isChecked) {
			this.notification.Message = "your child [firstname]" + this.notification.Message;
		} else {
			this.notification.Message = this.notification.Message.replace("[firstname]", "");
		}
	}

	onEntryDateChange(isChecked) {
		if (isChecked) {
			this.notification.Message = "[entrydate]" + this.notification.Message;
		} else {
			this.notification.Message = this.notification.Message.replace("[entrydate]", "");
		}
	}

	onEntryTimeChange(isChecked) {
		if (isChecked) {
			this.notification.Message = " arrived at [entrytime]" + this.notification.Message;
		} else {
			this.notification.Message = this.notification.Message.replace("[entrytime]", "");
		}
	}

	SaveNotification() {
		var item: any = this.notification;
		var ScheduleTime = moment(this.notification.AdmitTime).format("HH:mm:00");

		//Check Validation
		if (!item.NotificationTypeID) {
			this.SaveErrorMessage = "Select Notification Type";
			return;
		}

		//Check Validation
		if (!item.LanguageID) {
			this.SaveErrorMessage = "Select Language Type";
			return;
		}

		var result = this.adminSetupService.NotificationSchoolInsert(
			this.notification.NotificationTypeID,
			this.notification.Message,
			this.notification.Active,
			ScheduleTime,
			this.notification.SchoolID,
			this.notification.NotificationSchoolID
		);
		result.subscribe((response: any) => {
			var res: any = response;

			this.router.navigate(["/adminsetup/scheduler"]);
		});
	}

	Cancel() {
		this.router.navigate(["/adminsetup/scheduler"]);
	}
}
